<template>
  <div :class="classes">
    <span>{{ item[header.key] }}</span>
  </div>
</template>

<style>
.cell {
  max-width: v-bind(itemMaxWidth);
}
</style>

<script >
import { computed } from '@vue/composition-api'
import TableHeader from '@/models/components/table/TableHeader'

export default {
  props: {
    header: {
      type: TableHeader,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const itemMaxWidth = computed(() => `${props.header.maxWidth}px`)

    const classes = computed(() => {
      let str = 'cell'

      if (props.header.align === 'center') {
        str += ' d-flex justify-center'
      }

      return str
    })

    return {
      itemMaxWidth,
      classes,
    }
  },
}
</script>
